import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QueryKey } from 'consts/query/queryKey'
import { Agent } from 'types'

import { getAgents } from './requests'

export const useAgentsQuery = (options: Partial<UseQueryOptions<Agent[]>> = {}) => {
  return useQuery({
    queryKey: [QueryKey.GetAgents],
    queryFn: () => getAgents(),
    ...options,
  })
}
